import { environment } from './environments/environment';

const awsconfigtrainee = {
    Auth: {
        Cognito: {
            userPoolId: environment.COGNITO_USER_POOL,
            userPoolClientId: environment.COGNTIO_APP_CLIENT_ID,
            loginWith: { email: true },
        },
    },
};
export default awsconfigtrainee;
